export enum EZoneProduct {
  BASIC = 'basic',
  PREMIUM = 'premium',
}

export enum EZoneStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  DRAFT = 'draft',
  INACTIVE = 'inactive',
}

export enum EZoneCreateStatus {
  ADD_ZONE = 'add-zone',
  APPROVE_DECAL = 'approve-decal',
}

export enum EZoneCleaningHistoryItemStatus {
  COMPLETED = 'completed',
  ADDITIONAL_SERVICE = 'additional',
  MISSED = 'missed',
  REMAINS = 'remains',
}

export enum EZoneTargetCleaningType {
  NONE = ' none',
  FREQUENCY = 'frequency',
  SCHEDULE = 'schedule',
}

export enum EZoneTargetDuration {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  ANNUALLY = 'annually',
}
